<div #toHide>
    <h1 class="head-text" >Welcome to LookzUp</h1>
    <p class="head-text1" >Join the platform and manage your Salon, Parlour, Spa and Make-up Studio like never before</p>
   


    <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step [stepControl]="firstFormGroup">
          <form [formGroup]="firstFormGroup">
            <ng-template matStepLabel>Mobile</ng-template>
            <div class="row g-2  justify-content-between phone-field">
              <mat-form-field appearance="outline" class="col-3 country_form">
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" required (selectionChange)="onCountrySelected($event)" >
                  <mat-select-trigger>
                    {{ "(" + countryCode.value.dial_code + ")" }}
                  </mat-select-trigger>
                    <input
                    style="width: 80%;
                    height: 25px;
                    padding: 10px;
                    border: 1px solid lightgray;
                    margin: 10px;
                    border-radius: 5px;"
                    [formControl]="searchString"
                      matInput
                      placeholder="Enter country name"
                      (keyup)="onKey()"
                    />
                  <mat-option
                    *ngFor="let country of countryList"
                    [value]="country"
      
                  >
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="mobile_form col-9" appearance="outline" >
                <mat-label>Mobile</mat-label>
                <input type="tel" matInput #input  formControlName="phoneNo" placeholder="Enter your mobile number" autocomplete="off" maxlength="10" pattern="[0-9.]+" smNumericOnly>
              </mat-form-field>
            </div>
          
            <div>
              <button mat-button class="signupbutton" (click)="onSendOTP()" [disabled]="firstFormGroup.invalid">Verify mobile</button>
              <button mat-button matStepperNext #semiFinalButton class="verifyButton" >Submit</button>
              <!-- (click)="onSendOTP()" -->
            </div>

            <div class="manage_textc" style="padding: 0px 16px 0px 0px;">
              <!-- [routerLink]="['/business']" -->
              <p>Looking for beauty and grooming services for you and family?
               <a target="_blank"  href="https://lookzup-platform-dev.web.app/">
                Login here.</a>
              </p>
            </div>

            <div>
                <p>By clicking Sign up and registering with us, you are agreeing and consenting to our <span><a  style="color: #f20c49;" (click)="openTerms()" href="https://lookzup.com/terms" target="_blank">Terms of Services</a></span> and <span ><a style="color: #f20c49;" (click)="openPrivacy()" href="https://lookzup.com/privacy" target="_blank">Privacy policy</a></span></p>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup" >
          <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>OTP</ng-template>
            <mat-form-field class="formField" appearance="outline">
              <mat-label>Verification Code</mat-label>
              <input matInput formControlName="otp" autocomplete="off" placeholder="Enter your OTP" maxlength="6" pattern="[0-9.]+" smNumericOnly (keyup)="onOtpType()">
              <mat-hint style="margin-top: 5px;font-size: 13px;
            padding-left: 2px;">Enter the verification code you received in your mobile from LookzUp platform.</mat-hint>
            </mat-form-field>
            <!-- <div class="row">
                <div class="col-sm-7">
                    <button mat-button matStepperPrevious class="mobileChangeButton">Change mobile number</button>
                </div>
                <div class="col-sm-5">
                    <button mat-button #submitButton class="verifyButton" (click)="onSignIn()" >Login</button>
                    <button mat-button matStepperNext #finalButton class="verifyButton" >Submit</button>
               
                </div>


            </div> -->
            <div class="row for_higher" style="margin-top: 25px;">
              <div class="col-sm-7">
                  <button mat-button matStepperPrevious class="mobileChangeButton">Change mobile number</button>
              </div>
              <div class="col-sm-5">
                  <button mat-button #submitButton class="verifyButton" (click)="onSignIn()" [disabled]="isOtpInValid">Login</button>
                  <button mat-button matStepperNext #finalButton class="verifyButton" style="display: none;">Submit</button>
                
              </div>


          </div>
            <div class="row for_responsive" style="margin-top: 40px;">
              <div class="col-sm-7" style="margin-bottom: 10px;">
                <button mat-button #submitButton class="verifyButton" (click)="onSignIn()" [disabled]="isOtpInValid">Login</button>
                <button mat-button matStepperNext #finalButton class="verifyButton" style="display: none;">Submit</button>
              </div>
              <div class="col-sm-5">

                  <button mat-button matStepperPrevious class="mobileChangeButton">Change mobile number</button>
                  
              </div>


          </div>
          
            <hr>
            <div >
                <button type="button" class="w-100" mat-button matSuffix style=" font-weight: normal;
                font-size: 13px;
                color: #363636;">
                Haven't received any verification code yet? <span class="resend_tter">Resend</span>
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="signInForm" *ngIf="needToRegister">
          <form [formGroup]="signInForm">
            <ng-template matStepLabel>Profile</ng-template>
            <div class="row g-2 mb-3 justify-content-between phone-field">
              
              <mat-form-field appearance="outline" class="col-12">
                <mat-label>Name</mat-label>
                <input
                  matInput
                  type="tel"
                  formControlName="name"
                  required
                />
                
              </mat-form-field>
              <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()">
                  <mat-label>Date of birth</mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="dob" readonly>
                  <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field>
                <div class="radio_group">
                  <label>Gender: </label>
                  <mat-radio-group formControlName="gender">
                    <mat-radio-button value="Male">Male</mat-radio-button>
                    <mat-radio-button value="Female">Female</mat-radio-button>
                    <mat-radio-button value="Others">Others</mat-radio-button>
                  </mat-radio-group>
                </div>
                <mat-form-field appearance="outline">
                  <mat-label>Address</mat-label>
                  <input
                  formControlName="address"
                    matInput
                    (input)="updateSearchResults()"
                    [matAutocomplete]="auto"
                  />
                  <!-- <mat-icon matSuffix class="material-icons-outlined"
                    >person_pin_circle</mat-icon
                  > -->
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      *ngFor="let item of autocompleteItems"
                      (click)="selectSearchResult(item)"
                    >
                      {{ item.description }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
            </div>
            
            <button
              mat-flat-button
             style="    width: 100%;
             background: #f20c49;
             border-radius: 20px;
             color: white;
             height: 40px;"
              class="w-100"
              [disabled]="signInForm.invalid"
              (click)="onRegister()"
              #submitButton
            >
              Save and Go
            </button>
          </form>
            <ng-template matStepContent>
                <h1 class="head-text2" *ngIf="isAlreadyRegistered == 'no'">Bingo!</h1>
                <p *ngIf="isAlreadyRegistered == 'no'">You are registered successully</p>
                <h1 class="head-text2" *ngIf="isAlreadyRegistered == 'yes'">Hey, there!</h1>
                <p *ngIf="isAlreadyRegistered == 'yes'">You are already registered</p>
                <p *ngIf="isAlreadyRegistered == 'yes' ||isAlreadyRegistered == 'no' ">Now download the LookzUp Business app from Google Play Store or Apple App Store. Install in your phone, login, and start managing your Salon, Parlour, Spa and Make-up Studio</p>
                <div class="playstore-img">


                <div class="play_store_social d-flex" *ngIf="isAlreadyRegistered == 'yes' ||isAlreadyRegistered == 'no' ">
                  <div class="" style="
                  margin-right: 15px;">

                      <img class="linkImages" src="./assets/images/playstore.png" (click)="openLink('https://play.google.com/store/apps/details?id=com.lookzup.app.android.business')">
                  </div>
                  <div class="">
                      <img class="linkImages" src="./assets/images/applestore.png" (click)="openLink('https://apps.apple.com/us/app/lookzup-business/id1556242345')">
                  </div>
              </div>
            </div>
            </ng-template>
          <ng-template matStepLabel>Registration</ng-template>

        </mat-step>

      </mat-horizontal-stepper>
</div>

<div *ngIf="toshowblockedmessage">
  <div>
    <h1 class="head-text" >Your account is blocked.</h1>
    <p class="head-text1" >LookzUp Admin blocked your account due to the following reason:</p>
    <p class="head-text1" style="font-weight: 600;">{{blockedUserData.block_reason}}</p>
  </div>
  <div style="margin: 20px 24px 0px;border-top: 1px solid lightgrey;padding-top: 15px;">
    <p class="">Provide grievance or request unblock.</p>
    <mat-form-field class=" w-100"  style="margin-top: 0px;" appearance="outline" >
      <textarea matInput #input placeholder="Enter your grievance" autocomplete="off" [(ngModel)]="blockedUserGrievance"></textarea>
    </mat-form-field>
  </div>
  <div style="    text-align: right;
    margin: 0px 24px 0px;">
    <button
    style="margin-bottom: 20px;"
    mat-flat-button
    color="accent"
    [disabled]="!blockedUserGrievance"    
    (click)="sendUnblockRequest()"
  >
    Send
  </button>
  </div>
 
</div>

<div *ngIf="registrationDone && currentScreenWidth < 1200">
  <div style="padding: 24px;">
    <h1 class="head-text2" *ngIf="isAlreadyRegistered == 'no'">Bingo!</h1>
    <p *ngIf="isAlreadyRegistered == 'no'">You are registered successully.</p>
    <h1 class="head-text2" *ngIf="isAlreadyRegistered == 'yes'">Hey, there!</h1>
    <p *ngIf="isAlreadyRegistered == 'yes'">You are already registered.</p>
    <p *ngIf="isAlreadyRegistered == 'yes' ||isAlreadyRegistered == 'no' ">Now download the LookzUp Business app from Google Play Store or Apple App Store. Install in your phone, login, and start managing your Salon, Parlour, Spa and Make-up Studio.</p>
    <div class="playstore-img">
  
  
    <div class="play_store_social d-flex" *ngIf="isAlreadyRegistered == 'yes' || isAlreadyRegistered == 'no' ">
      <div class="" style="
      margin-right: 15px;">
  
          <img class="linkImages" src="./assets/images/playstore.png" (click)="openLink('https://play.google.com/store/apps/details?id=com.lookzup.app.android.business')">
      </div>
      <div class="">
          <img class="linkImages" src="./assets/images/applestore.png" (click)="openLink('https://apps.apple.com/us/app/lookzup-business/id1556242345')">
      </div>
  </div>
  </div>
  </div>
</div>
